import types from './types';

const toggle = state => ({
  type: types.TOGGLE_GIS_MODAL,
  state: state || false
});

export default {
  toggle
};

export const actions = {
  toggle
};
